import * as urls from '@apps-common/js-client/api/urls';
import request from '@apps-common/js-client/api/request';
import {LicenseInfo} from '@mui/x-license-pro';
import {setGraneroTarget} from '@apps-common/geocorn-sdk/api';

// MUI X Setup
LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_X_KEY);

// Set Granero to "prod"
setGraneroTarget('live');

export const isDev = import.meta.env.MODE === 'development';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// this injects the value as the base url for all requests
urls.setBase(API_BASE_URL);
request.defaults.baseUrl = API_BASE_URL;

export const DATA_API_URL =
  import.meta.env.VITE_DATA_API_URL || `${API_BASE_URL}/data/v1`;

export const MOSAICS_ENDPOINT =
  import.meta.env.VITE_MOSAICS_ENDPOINT ||
  `${API_BASE_URL}${import.meta.env.VITE_BASEMAPS_API_BASE}/mosaics`;

export const SERIES_ENDPOINT =
  import.meta.env.SERIES_ENDPOINT ||
  `${API_BASE_URL}${import.meta.env.VITE_BASEMAPS_API_BASE}/series`;

export const ORDERS_ENDPOINT =
  import.meta.env.VITE_ORDERS_ENDPOINT ||
  `${API_BASE_URL}/compute/ops/orders/v2`;

export const ORDERS_POSTFIX = 'Explorer';

export const BING_TOKEN = import.meta.env.VITE_BING_TOKEN;
export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

export const BASE_LAYER_URL =
  'mapbox://styles/planet/ck8yzkkra05tv1ip9os6pmi1e';

export const LABELS_STYLE_URL =
  'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018';

export const STILES_LAYER_URL = import.meta.env.VITE_STILES_LAYER_URL;

export const TILES_BASE_URL = import.meta.env.VITE_TILES_BASE_URL;
export const TILES_HOSTNAME = import.meta.env.VITE_TILES_HOSTNAME;

export const CAPABILITIES_ENDPOINT =
  import.meta.env.CAPABILITIES_ENDPOINT ||
  `${import.meta.env.VITE_TILES_BASE_URL}${
    import.meta.env.VITE_BASEMAPS_API_BASE
  }/caps/`;

export const BASEMAP_RULES_URL =
  import.meta.env.VITE_BASEMAP_RULES_URL ||
  `${import.meta.env.VITE_BASEMAPS_API_BASE}/rules`;

export const BASEMAP_RT_QUOTA_URL =
  import.meta.env.VITE_BASEMAP_RT_QUOTA_URL ||
  `${import.meta.env.VITE_TILES_BASE_URL}${
    import.meta.env.VITE_BASEMAPS_API_BASE
  }/quota`;

export const DISABLE_GEOCODER = !!import.meta.env.VITE_DISABLE_GEOCODER;

export const TASKING_URL = import.meta.env.VITE_TASKING_URL;

export const FOLDERS_TILES_URL =
  import.meta.env.VITE_FOLDERS_TILES_URL ||
  `${TILES_HOSTNAME}/data/v1/folder/tiles`;

export const ITEMS_TILES_URL =
  import.meta.env.VITE_ITEMS_TILES_URL || `${TILES_HOSTNAME}/data/v1`;

export const FOLDERS_API_URL =
  import.meta.env.VITE_FOLDERS_API_URL ||
  `${API_BASE_URL}/hosted-data/v0/folders`;

export const BLOBZ_API_URL =
  import.meta.env.VITE_BLOBZ_API_URL || `${API_BASE_URL}/apps/v0/b`;

export const PDA_ADMIN_URL =
  import.meta.env.VITE_PDA_ADMIN_URL ||
  `${API_BASE_URL}${import.meta.env.VITE_PDA_ADMIN_BASE}`;

export const PLANET_TILE_SERVER_ENCODINGS = {
  jpg: true,
  png: true,
};

function check_webp_feature(feature, callback) {
  const kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha:
      'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation:
      'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
  };
  const img = new Image();
  img.onload = function () {
    callback(feature, img.width > 0 && img.height > 0);
  };
  img.onerror = function () {
    callback(feature, false);
  };
  img.src = 'data:image/webp;base64,' + kTestImages[feature];
}

check_webp_feature('alpha', (feature, supported) => {
  PLANET_TILE_SERVER_ENCODINGS.webp = supported;
});
